import { isEmpty } from '@ember/utils';
import currency from 'currency.js';

export default {
  // serializes a string value to a number
  // if the value is empty, then it returns null
  deserializeNumber(valString: string): Number | null {
    if (isEmpty(valString)) {
      return null;
    }
    return Number(valString);
  },

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
  roundPrecision(number: number, precision: number): number {
    let factor = Math.pow(10, precision);
    return Math.round(number * factor) / factor;
  },

  // taken from https://github.com/offirgolan/ember-validators/blob/master/addon/number.js#L109
  isNumber(value: any): boolean {
    return typeof value === 'number' && !isNaN(value);
  },

  isInteger(value: any): boolean {
    return (
      typeof value === 'number' &&
      isFinite(value) &&
      Math.floor(value) === value
    );
  },

  milesToMeters(miles: number): number {
    return miles / 0.00062137;
  },

  addCurrency(a: number, b: number): number {
    return currency(a).add(b).value;
  },
};
